export enum RbacMode {
  SCOPED = "scoped",
  ADMIN = "admin",
}
export enum OnError {
  AUDIT = "audit",
  IGNORE = "ignore",
  REJECT = "reject",
}

export const UUID_LENGTH_LIMIT = 36;
